<b>Orders by Status</b>
<hr>
@if (loaded) {
  <ngx-charts-bar-vertical
    [view]="view"
    [scheme]="colorScheme"
    [results]="dataBar"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showYAxisLabel]="showYAxisLabel"
    [yAxisLabel]="yAxisLabel"
    >
  </ngx-charts-bar-vertical>
}
